import { render, staticRenderFns } from "./PageMobileView.vue?vue&type=template&id=8a41ebee&scoped=true"
import script from "./PageMobileView.vue?vue&type=script&lang=js"
export * from "./PageMobileView.vue?vue&type=script&lang=js"
import style0 from "./PageMobileView.vue?vue&type=style&index=0&id=8a41ebee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a41ebee",
  null
  
)

export default component.exports